"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowService = void 0;
const tslib_1 = require("tslib");
const modal_service_1 = require("../components/modal/modal.service");
const i18n_1 = require("../i18n");
const index_1 = require("./index");
/**
 * Manages the native `window` object.
 *
 * Responsibilities include:
 * - mitigating browser incompatibilities
 * - propagating changes with legacy Angular codebase
 */
class WindowService {
    constructor() {
        this.__priority = 0;
        /** Whether navigation is being processed. Used to cancel duplicate navigation events from multiple bindings. */
        this.isNavigating = false;
        /** Whether navigation events have been bound to `window`. Used to ensure navigation events are bound once. */
        this.isStateBound = false;
        /** Navigation callbacks. */
        this.navigationListeners = [];
    }
    setWindow(window) {
        this.$window = window;
    }
    get window() {
        if (this.$window == null) {
            throw new Error('WindowService has not started');
        }
        return this.$window;
    }
    get document() {
        if (this.$window == null) {
            throw new Error('WindowService has not started');
        }
        return this.$window.document;
    }
    /**
     * Register a callback to be invoked when navigating to another page.
     *
     * @param msg Confirmation message when confirming navigation.
     * @param stopNavigate Callback which returns true or false to confirm or halt navigation.
     * @param options Optional modal customization for internal navigation.
     */
    bindNavigateAway(msg, stopNavigate, options) {
        this.ensureWindowEvents();
        this.navigationListeners.push(Object.assign({ msg, stopNavigate }, options));
    }
    /** De-register navigation callback function */
    unbindNavigateAway(stopNavigate) {
        this.navigationListeners = this.navigationListeners.filter((listener) => listener.stopNavigate !== stopNavigate);
    }
    /** De-register all navigation callback function */
    unbindAllNavigateAway() {
        this.navigationListeners.forEach((l) => this.unbindNavigateAway(l.stopNavigate));
    }
    ensureWindowEvents() {
        var _a;
        if (this.isStateBound) {
            return;
        }
        (_a = this.$window) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', this.confirmPageUnload.bind(this));
        this.isStateBound = true;
    }
    confirmPageUnload(event) {
        const listener = this.navigationListeners.find((l) => l.stopNavigate());
        if (listener == null) {
            delete event.returnValue;
            return undefined;
        }
        event.preventDefault();
        const message = (0, i18n_1.Translate)(listener.msg);
        event.returnValue = message;
        return message;
    }
    confirmPageChange(event, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            event.preventDefault();
            if (this.isNavigating) {
                return false;
            }
            this.isNavigating = true;
            const listener = this.navigationListeners.find((l) => l.stopNavigate());
            let result = {
                ok: true,
                cancel: false,
            };
            if (listener) {
                modal_service_1.ModalService.close();
                if (listener.blockNavigation) {
                    yield modal_service_1.ModalService.open({
                        title: (_a = listener.modalTitle) !== null && _a !== void 0 ? _a : i18n_1.T.DISCARD_CHANGES_TITLE,
                        content: (0, i18n_1.Translate)((_b = listener.modalContent) !== null && _b !== void 0 ? _b : listener.msg),
                        hasCancel: false,
                    });
                    this.isNavigating = false;
                    return false;
                }
                result = yield modal_service_1.ModalService.open({
                    title: (_c = listener.modalTitle) !== null && _c !== void 0 ? _c : i18n_1.T.DISCARD_CHANGES_TITLE,
                    content: (0, i18n_1.Translate)((_d = listener.modalContent) !== null && _d !== void 0 ? _d : i18n_1.T.DISCARD_CHANGES_CONFIRM),
                    okName: i18n_1.T.DISCARD_CHANGES_DISCARD,
                    hasCancel: true,
                });
            }
            if (result.ok) {
                this.unbindAllNavigateAway();
                this.isNavigating = false;
                (_e = index_1.Services.Window.$window) === null || _e === void 0 ? void 0 : _e.open(url, '_top');
                return true;
            }
            this.isNavigating = false;
            return false;
        });
    }
}
exports.WindowService = WindowService;
//# sourceMappingURL=window.service.js.map